import { render, staticRenderFns } from "./operationsRolesPreview.vue?vue&type=template&id=5063322e&scoped=true"
import script from "./operationsRolesPreview.vue?vue&type=script&lang=js"
export * from "./operationsRolesPreview.vue?vue&type=script&lang=js"
import style0 from "./operationsRolesPreview.vue?vue&type=style&index=0&id=5063322e&prod&scoped=true&lang=css"
import style1 from "./operationsRolesPreview.vue?vue&type=style&index=1&id=5063322e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5063322e",
  null
  
)

export default component.exports